import { ToolPageShell } from '@/shared/seo'
import { UdalitStranicyIzPdfForm } from './UdalitStranicyIzPdfForm'

export function UdalitStranicyIzPdfPage() {
  return (
    <ToolPageShell utilityKey="deletePdfPages">
      <UdalitStranicyIzPdfForm />
    </ToolPageShell>
  )
}
